import { autoinject, transient, useView } from "aurelia-framework";
import { ChildComponent } from "../../../child-component";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { RightShipInspectionClientModel, GetCrewMatricesByInspectionIdResponse, CrewMatrixItem } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { RightShipInspectionsService } from "../../../../../../services/rightship-inspections/rightship-inspections.service";
import * as moment from "moment";

@autoinject
@transient()
@useView('views/pages/modules/rightship-inspection/steps/crew-matrix/rightship-inspection-crew-matrix.html')
export class RightShipInspectionCrewMatrix extends ChildComponent<RightShipInspectionClientModel>
{
    public assignment: any;

    public deckOfficers: CrewMatrixItem[] = [];
    public engineers: CrewMatrixItem[] = [];
    public crewMatrixComment: string;
    public crewMatrixFormSubmitDate: string;
    public showDeckOfficers: boolean;
    public showEngineers: boolean;

    constructor(notificationsService: NotificationClientService, i18N: I18N,
        private rightshipInspectionsService: RightShipInspectionsService) {
        super(notificationsService, i18N);
    }

    async activate(model: any) {
        this.assignment = model.assignment;
        const getCrewMatricesResult: GetCrewMatricesByInspectionIdResponse = await this.rightshipInspectionsService.GetCrewMatricesByInspectionId({rightShipInspectionId: this.assignment.entityId});
        this.crewMatrixFormSubmitDate = moment(this.assignment.item.crewMatrixFormSubmitDate).format('DD MMM YYYY');

        getCrewMatricesResult.items.forEach(x =>{
            x.dateOfJoiningFormatted = moment(x.dateOfJoining).format('DD MMM YYYY');
        })

        this.deckOfficers = getCrewMatricesResult.items.filter(x => x.officerType == "Deck");
        this.engineers = getCrewMatricesResult.items.filter(x => x.officerType == "Engineers");
        this.crewMatrixComment = getCrewMatricesResult.crewMatrixComment;
        this.showDeckOfficers = this.deckOfficers.length > 0;
        this.showEngineers = this.engineers.length > 0;
    }
}